import { CLOUDINARY_BASE_URL } from '@99designs/design-services-common';
import type { CloudinaryImageOptions } from '../../../products/types';

type BreakPointNames = 'xs' | 'sm' | 'md' | 'lg';

const BREAKPOINTS: Record<BreakPointNames, number> = {
    xs: 768,
    sm: 1024,
    md: 1440,
    lg: 1920,
};

export type SrcSetWidths = Partial<Record<BreakPointNames, number>>;

export function buildCloudinaryURL(
    imagePath: string,
    transforms: CloudinaryImageOptions = {}
): string {
    if (!imagePath) {
        console.warn('No image path provided to buildCloudinaryURL');
        return '';
    }

    const sanitizedImagePath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    const transformations = ['c_scale', 'dpr_auto', 'f_auto', 'fl_progressive'];

    if (transforms.width) transformations.push(`w_${transforms.width}`);

    return `${CLOUDINARY_BASE_URL}${transformations.join(',')}/${sanitizedImagePath}`;
}

export function generateAllBreakpointSrcSet(
    imagePath: string,
    srcSetWidthsOverrides?: SrcSetWidths
): string {
    const breakPointKeys = Object.keys(BREAKPOINTS) as BreakPointNames[];

    return breakPointKeys
        .map((breakPoint) => {
            const url = buildCloudinaryURL(imagePath, {
                width:
                    (srcSetWidthsOverrides && srcSetWidthsOverrides[breakPoint]) ??
                    BREAKPOINTS[breakPoint],
            });
            return `${url} ${BREAKPOINTS[breakPoint]}w`;
        })
        .join(', ');
}
